/**
 * Seus dados — spec 0074 (FR-006, C-02).
 *
 * A família pede à cooperativa que apague os dados deste telefone. A página diz
 * antes o que some e o que fica — o resumo das viagens, pelo prazo de
 * contestação —, pede um segundo toque, e depois mostra que o pedido espera a
 * cooperativa.
 */

import React, { useEffect, useState } from 'react';
import { type Chamar, ErroDaPagina, diaCurto } from './familia-comum';

export const SeusDados: React.FC<{ chamar: Chamar }> = ({ chamar }) => {
  const [aberto, setAberto] = useState<{ criadoEm: string | null } | null | undefined>(undefined);
  const [confirmando, setConfirmando] = useState(false);
  const [descricao, setDescricao] = useState('');
  const [ocupado, setOcupado] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    chamar<{ criadoEm: string | null } | null>('/exclusao').then(setAberto).catch(() => setAberto(null));
  }, [chamar]);

  const pedir = async () => {
    setErro(null);
    setOcupado(true);
    try {
      await chamar('/exclusao', { method: 'POST', body: JSON.stringify({ descricao: descricao.trim() || undefined }) });
      setAberto({ criadoEm: new Date().toISOString() });
      setConfirmando(false);
    } catch (e) {
      setErro(e instanceof ErroDaPagina && e.codigo === 'PEDIDO_DUPLICADO' ? 'Já há um pedido seu esperando a cooperativa.' : (e as Error).message);
    } finally {
      setOcupado(false);
    }
  };

  if (aberto === undefined) return null;
  return (
    <section className="fam-bloco" aria-labelledby="fam-dados-titulo">
      <h2 id="fam-dados-titulo" className="fam-secao">Seus dados</h2>
      {aberto ? (
        <p className="fam-aviso" role="status">
          Você pediu a exclusão dos dados deste telefone{aberto.criadoEm ? ` em ${diaCurto(aberto.criadoEm.slice(0, 10))}` : ''}. A cooperativa
          vai responder por aqui.
        </p>
      ) : !confirmando ? (
        <>
          <p className="fam-apoio">
            Você pode pedir que a cooperativa apague os dados deste telefone: o seu cadastro como responsável, as conversas e
            os lugares por onde a van passou com a criança.
          </p>
          <button type="button" className="fam-btn fam-btn-texto" onClick={() => setConfirmando(true)}>Pedir a exclusão dos meus dados</button>
        </>
      ) : (
        <div className="fam-form fam-falta-form">
          <h3 className="fam-subtitulo">Pedir a exclusão</h3>
          <p className="fam-apoio">
            Depois que a cooperativa atender, este telefone para de receber os avisos do transporte. O resumo das viagens
            (quem embarcou e a que horas) fica guardado por 5 anos, o prazo para contestar uma viagem.
          </p>
          <div className="fam-campo">
            <label className="fam-rotulo" htmlFor="fam-dados-motivo">Quer dizer o motivo? (opcional)</label>
            <input id="fam-dados-motivo" type="text" maxLength={300} value={descricao} onChange={(e) => setDescricao(e.target.value)}
              placeholder="Ex.: meu filho mudou de escola" />
          </div>
          {erro && <p className="fam-erro" role="alert">{erro}</p>}
          <div className="fam-acoes">
            <button type="button" className="fam-btn fam-btn-texto" onClick={() => setConfirmando(false)} disabled={ocupado}>Voltar</button>
            <button type="button" className="fam-btn fam-btn-primario" onClick={pedir} disabled={ocupado}>{ocupado ? 'Enviando…' : 'Pedir a exclusão'}</button>
          </div>
        </div>
      )}
    </section>
  );
};
